import axios from '@axios'
import axiosRu from '@axios-ru'

// Хранилище вопросов. Бэкенд: routes/api.php — префиксы question-storage, question-storage/import, question-mechanics
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Справочники: механики со слотами, декады, кластеры, происхождения → {data: {...}}
    fetchLookups() {
      return axios.get('/question-storage/lookups')
    },
    fetchQuestions(ctx, params) {
      return axios.get('/question-storage/questions', { params })
    },
    fetchQuestion(ctx, id) {
      return axios.get(`/question-storage/questions/${id}`)
    },
    updateQuestion(ctx, { id, data }) {
      return axios.put(`/question-storage/questions/${id}`, data)
    },
    updatePart(ctx, { questionId, partId, data }) {
      return axios.put(`/question-storage/questions/${questionId}/parts/${partId}`, data)
    },
    deletePart(ctx, { questionId, partId }) {
      return axios.delete(`/question-storage/questions/${questionId}/parts/${partId}`)
    },
    reorderParts(ctx, { questionId, partIds }) {
      return axios.post(`/question-storage/questions/${questionId}/parts/reorder`, { part_ids: partIds })
    },
    addTextPart(ctx, { questionId, data }) {
      return axios.post(`/question-storage/questions/${questionId}/parts`, data)
    },

    // Метки исполнителей для ручной привязки: ids → {data: {<artistId>: {decades, cluster_ids, origin}}}
    fetchArtistTags(ctx, ids) {
      return axios.get('/question-storage/artist-tags', { params: { ids } })
    },

    fetchArtists(ctx, params) {
      return axios.get('/question-storage/artists', { params })
    },

    fetchPacks(ctx, params) {
      return axios.get('/question-storage/packs', { params })
    },
    fetchPack(ctx, id) {
      return axios.get(`/question-storage/packs/${id}`)
    },
    attachPlanfixPack(ctx, { gameId, planfixPackId }) {
      return axios.put(`/question-storage/packs/${gameId}/planfix-pack`, { planfix_pack_id: planfixPackId })
    },
    deletePack(ctx, id) {
      return axios.delete(`/question-storage/packs/${id}`)
    },

    // FormData с файлом `file` или {planfix_pack_id}
    prepareImport(ctx, payload) {
      return axios.post('/question-storage/import/prepare', payload)
    },
    // Загрузка .siq с прогрессом: тот же prepare, но multipart с onUploadProgress
    uploadImport(ctx, { formData, onUploadProgress }) {
      return axios.post('/question-storage/import/prepare', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
      })
    },
    // Справочник ПФ-пакетов для шапки импорта: {packs: [{id (planfix_packs.id или null), key, name, file_path, ...}]}
    fetchPlanfixPacks() {
      return axios.get('/planfix-packs')
    },
    retagImport(ctx, { token, data }) {
      return axios.post(`/question-storage/import/${token}/retag`, data)
    },
    // Смена ПФ-пакета в шапке → {draft} пересобранный (даты, повторный импорт, блокировка)
    changeImportPlanfixPack(ctx, { token, planfixPackId }) {
      return axios.post(`/question-storage/import/${token}/planfix-pack`, { planfix_pack_id: planfixPackId })
    },
    commitImport(ctx, { token, draft }) {
      return axios.post(`/question-storage/import/${token}/commit`, draft)
    },

    fetchMechanics() {
      return axios.get('/question-mechanics')
    },
    createMechanic(ctx, data) {
      return axios.post('/question-mechanics', data)
    },
    updateMechanic(ctx, { id, data }) {
      return axios.put(`/question-mechanics/${id}`, data)
    },
    deleteMechanic(ctx, id) {
      return axios.delete(`/question-mechanics/${id}`)
    },

    // Поиск сущностей для чипов привязок: ответ {data: [...]}
    searchArtists(ctx, q) {
      return axios.get('/artist', { params: { q, per_page: 20 } })
    },
    searchTracks(ctx, { q, artistId }) {
      return axios.get('/track', { params: { q, artist_id: artistId || undefined, per_page: 20 } })
    },
    searchMovies(ctx, q) {
      return axiosRu.get('/movie', { params: { q, per_page: 20 } })
    },
    // Обложки артиста: ответ — массив [{id, name, url, ...}]
    fetchArtistCovers(ctx, artistId) {
      return axios.get(`/artist/${artistId}/covers`)
    },
  },
}
